/*
 * File: getDriveHistorySummary.ts
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */

import type { StudentPeriodEnrollment } from 'types/students';

/**
 * Helper function to generate drive history summary text
 */
export function getDriveHistorySummary(enrollments: StudentPeriodEnrollment[]): string {
  const completedDrives = enrollments.filter((e) => e.attendance === 'present').length;
  const noShowDrives = enrollments.filter((e) => e.attendance === 'absent').length;
  const noPermitDrives = enrollments.filter((e) => e.attendance === 'no_permit').length;
  const canceledDrives = enrollments.filter((e) => e.canceled_at).length;

  const parts = [`${completedDrives} completed`];
  if (noShowDrives > 0) parts.push(`${noShowDrives} no-show${noShowDrives > 1 ? 's' : ''}`);
  if (noPermitDrives > 0) parts.push(`${noPermitDrives} no permit${noPermitDrives > 1 ? 's' : ''}`);
  if (canceledDrives > 0) parts.push(`${canceledDrives} canceled`);

  return parts.join(', ');
}

/**
 * Helper function to calculate drive history stats
 */
export function getDriveHistoryStats(enrollments: StudentPeriodEnrollment[]) {
  return {
    completedCount: enrollments.filter((e) => e.attendance === 'present').length,
    noShowCount: enrollments.filter((e) => e.attendance === 'absent').length,
    noPermitCount: enrollments.filter((e) => e.attendance === 'no_permit').length,
    upcomingCount: enrollments.filter((e) => !e.attendance && !e.canceled_at).length,
    canceledCount: enrollments.filter((e) => e.canceled_at).length,
  };
}
